module.exports = "<div class=\"row m-0\">\n  <div class=\"col border border-secondary rounded\">\n    <h1 class=\"mt-5 mb-5 text-center\"> {{title}} </h1>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main